import { cloneDeep, merge } from 'lodash'

import messages from '@sigma-frontend-libs/messages'

import notifications from './notifications'
import settingsUser from './settingsUser'

const granularCommonLabels = merge(cloneDeep(settingsUser.labels), {
  sendings: {
    phoneNumber: {
      checkMobile: 'Check mobile phone number'
    }
  },

  billings: {
    autoAccrual: 'Auto top-up'
  },

  referral: {
    billings: {
      processedChildOperations: 'Process financial operations of the referral program for child users'
    }
  },

  webhooks: 'Webhooks',

  notifications: {
    enabled: 'Notifications enabled',

    events: {
      billings: {
        limit: 'Balance threshold notification [DEPRECATED]'
      },

      tariff: {
        update: 'Tariff update notification'
      },

      balance: {
        limit: 'Balance threshold notification',
        accrual: 'Balance accrual notification',
        daily: 'Daily balance notification'
      },

      auth: {
        registration: 'Registration notification',
        recover: 'Password recovery notification'
      },

      pattern: {
        approved: 'Template approved notification',
        rejected: 'Template rejected notification'
      },

      sendername: {
        approved: 'Sender name approved notification',
        rejected: 'Sender name rejected notification'
      },

      sendings: {
        bulk: {
          created: 'Bulk sending created notification',
          paused: 'Bulk sending paused notification',
          resumed: 'Bulk sending resumed notification'
        }
      },

      system: {
        platform: {
          issues: 'Platform system issue notification'
        },

        route: {
          issues: 'Routing system issue notification'
        }
      }
    },

    email: {
      recipients: 'Email notification recipients'
    },

    sms: {
      recipients: 'SMS notification recipients'
    }
  },

  integrations: {
    pyrus: {
      credentials: 'Credentials for Pyrus integration'
    }
  },

  reports: {
    maxConcurrentGenerating: 'Maximum number of concurrently generated reports'
  }
})

export default {
  title: 'Permissions',

  subtitles: {
    presets: 'Presets'
  },

  dialogs: {
    titles: {
      info: 'Information about permission levels'
    }
  },

  labels: {
    create: 'Create',
    check: 'Check number',
    finalize: 'Finalize',
    find: 'Find',
    generate: 'Generate',
    set: 'Set',
    get: 'Get',
    use: 'Use',
    getSendingsForTask: 'Get sendings for task',
    remove: 'Remove',
    update: 'Update',
    modify: 'Modify',
    seek: 'Seek',
    download: 'Download',
    upload: 'Upload',
    setRead: 'Set read',
    setPermissions: 'Set permissions',
    setRoutingGroups: 'Set routing groups',
    setMessageRuleGroups: 'Set message rule groups',
    setSettings: 'Set settings',
    setSendernames: 'Set sender names',
    setPatterns: 'Set patterns',
    setTariffs: 'Set tariffs',
    showSecrets: 'Show secret permissions',
    trigger: 'Trigger',
    health: 'Performance',
    loginAs: 'Login as',
    request: 'Request',
    controlDocuments: 'Work with documents',
    edit: 'Edit',
    viewChangelogs: 'View changelogs',
    contracts: 'Contracts',
    companies: 'Companies',
    documentTemplates: 'Document templates',
    refund: 'Refund payment',
    presetUsersBalance: 'Download user list',
    matchKeywords: 'Match keywords',
    setOtpChannels: 'Set OTP channels',
    setHasContract: 'Set contract presence',

    ...messages.en['report-manager'].types,

    ...settingsUser.paths,

    notifications: {
      enabled: 'Notifications enabled',

      events: notifications.events,
      childrenUsersEvents: notifications.childrenUsersEvents,

      email: {
        recipients: 'Email notification recipients'
      },

      sms: {
        recipients: 'SMS notification recipients'
      }
    },

    me: {
      settingsUser: granularCommonLabels
    },

    child: {
      settingsUser: granularCommonLabels
    }
  },

  hints: {
    warning: 'Changing permissions does not require user update.'
  },

  tooltips: {
    info: 'Information about permission levels'
  },

  buttons: {
    false: 'False',
    me: 'User',
    reseller: 'Reseller'
  },

  origins: {
    me: 'Own',
    child: 'Child'
  },

  services: {
    ...messages.en.services,

    referral: 'Referral program',
    integrations: 'Integrations',
    webhooks: 'Webhooks',
    websocket: 'WebSocket',
    smpp: 'SMPP',
    granular: 'Granular',
    secret: 'Secrets',

    child: {
      settingsUser: 'Child user settings'
    },

    me: {
      settingsUser: 'Own user settings'
    }
  },

  accepts: {
    false: 'Prohibits any actions that require corresponding permission.',
    me: 'Allows actions with objects that the user created, or that their reseller or administrator created for them.',
    manager: 'Allows actions with objects that belong to the user or to users assigned to the manager.',
    reseller: 'Allows actions with objects that belong to the user or to the reseller\'s child users.',
    true: 'Allows actions with any objects in the system.',
    default: 'Default permission.',
    read: 'Allows only reading the value, but does not allow modifying it.',
    write: 'Allows reading and modifying the value.'
  },

  snackbars: {
    updated: 'Permission successfully updated'
  },

  tooltips: {
    accepts: {
      default: 'Permission to view or edit this setting has not been modified.',
      read: 'You are allowed to only view the value.',
      write: 'You are allowed to view and edit the value.'
    },

    origins: {
      me: 'Permissions control access to viewing and editing the users own settings (on top of the base schema).',
      child: 'Permissions control access to viewing and editing settings of child users (on top of the base schema).'
    }
  },

  tabs: {
    advanced: 'Advanced',
    granular: 'Granular',
    secret: 'Secret'
  }
}
